<template>
  <div class="px-6 py-16 bg-white lg:px-8">
    <title>Privacy Policy - Dhanvantaree</title>
    <div class="max-w-5xl mx-auto text-base leading-7 text-gray-700">
      <h1
        class="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl"
      >
        Terms of Service
      </h1>
      <p class="mt-6 text-xl leading-8">
        Rajdoot Services - Terms of Service
      </p>
      <p class="mt-3 text-xl font-bold leading-8">
        Effective Date: 1st July 2024
      </p>
      <p class="mt-4">
        Welcome to Rajput Electricals! By accessing our website or availing of
        our services, you agree to comply with and be bound by these Terms and
        Conditions. If you do not agree, please do not use our services.
      </p>
      <div class="px-4 mt-10">
        <ul class="mt-4 space-y-6 text-gray-600 list-decimal">
          <li>
            <span class="text-lg font-extrabold">Services Overview</span>
            <ul class="pl-10 space-y-2 list-disc">
              <li>
                Rajput Electricals offers electrical and appliance repair
                services through our team of skilled electricians.
              </li>
              <li>
                Services can be booked online via the website or by visiting our
                shop directly.
              </li>
              <li>
                Our electricians will visit your location for repairs and, if
                needed, procure spare parts from our shop to complete the
                service.
              </li>
            </ul>
          </li>
          <li>
            <span class="text-lg font-extrabold">Service Requests</span>
            <ul class="pl-10 space-y-2 list-disc">
              <li>
                Service requests must be booked with accurate and complete
                information about the issue.
              </li>
              <li>
                Service appointments are subject to availability.
              </li>
            </ul>
          </li>
          <li>
            <span class="text-lg font-extrabold">Registration Process</span>
            <ul class="pl-10 space-y-2 list-disc">
              <li>
                To use our services, you must complete the registration process
                and provide accurate information about your clinic, including
                the admin profile details.
              </li>
              <li>
                You must ensure that you have legal ownership or proper
                authorisation of your clinic.
              </li>
            </ul>
          </li>
          <li>
            <span class="text-lg font-extrabold">Billing and Payments</span>
            <ul class="pl-10 space-y-2 list-disc">
              <li>
                After the service, you will be provided with a detailed bill
                covering labor charges and the cost of any spare parts.
              </li>
              <li>
                Payments must be made upon receipt of the bill via cash, online
                transfer, or any other accepted payment methods.
              </li>
            </ul>
          </li>
          <li>
            <span class="text-lg font-extrabold">Ownership and Use</span>
            <ul class="pl-10 space-y-2 list-disc">
              <li>
                You retain ownership of your information. After registration,
                you grant us the right to maintain and use this information as
                necessary to provide our services.
              </li>
              <li>
                We may use aggregated and anonymised data for statistical
                analysis and other legitimate purposes.
              </li>
            </ul>
          </li>
          <li>
            <span class="text-lg font-extrabold">Warranties and Liability</span>
            <ul class="pl-10 space-y-2 list-disc">
              <li>
                Spare parts purchased from our shop may have a manufacturer
                warranty, if applicable. Rajput Electricals is not responsible
                for manufacturer defects.
              </li>
              <li>
                Rajput Electricals provides a service guarantee for labor for a
                specified period, as communicated at the time of service.
              </li>
              <li>
                We are not liable for any indirect or consequential damages
                arising from delays, failure of spare parts, or incorrect usage
                post-repair.
              </li>
            </ul>
          </li>

          <li>
            <span class="text-lg font-extrabold">Customer Obligations</span>
            <ul class="pl-10 space-y-2 list-disc">
              <li>
                Ensure safe access to your property for our electricians during
                the scheduled service time.
              </li>
              <li>
                Disclose any specific electrical or appliance conditions or
                issues prior to service.
              </li>
            </ul>
          </li>
          <li>
            <span class="text-lg font-extrabold">
              Cancellations and Refunds</span
            >
            <p class="pl-4">
              <ul class="pl-10 space-y-2 list-disc">
              <li>
                Cancellation requests should be made at least 24 hours prior to the scheduled service.

              </li>
              <li>
                Refunds for canceled services are subject to approval and may exclude any costs already incurred.

              </li>
            </ul>
            </p>
          </li>
        </ul>
      </div>
      <nav class="flex mt-10" aria-label="Breadcrumb">
        <ol role="list" class="flex px-0 space-x-2 ">
          <li>
            <div>
              <a
                id="terms-home"
                href="/"
                class="text-gray-400 hover:text-gray-500"
              >
                <svg
                  class="flex-shrink-0 w-5 h-5"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path
                    fill-rule="evenodd"
                    d="M9.293 2.293a1 1 0 011.414 0l7 7A1 1 0 0117 11h-1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-3a1 1 0 00-1-1H9a1 1 0 00-1 1v3a1 1 0 01-1 1H5a1 1 0 01-1-1v-6H3a1 1 0 01-.707-1.707l7-7z"
                    clip-rule="evenodd"
                  />
                </svg>
                <span class="sr-only">Home</span>
              </a>
            </div>
          </li>
          <li>
            <div class="flex items-center">
              <svg
                class="flex-shrink-0 w-5 h-5 text-gray-400"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  fill-rule="evenodd"
                  d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z"
                  clip-rule="evenodd"
                />
              </svg>
              <span
                class="ml-2 text-sm font-medium text-gray-400 cursor-default"
                >Terms Of Service</span
              >
            </div>
          </li>
        </ol>
      </nav>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  }
};
</script>
